import { render, staticRenderFns } from "./EventInfos.vue?vue&type=template&id=3b6cb9a6"
import script from "./EventInfos.js?vue&type=script&lang=js&external"
export * from "./EventInfos.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports